import type { TreeSelectProps } from 'antd';

interface TreeNode {
  title: string;
  value: string | number;
  key: string | number;
  children?: TreeNode[];
}

const DAYS: readonly [string, string][] = [
  ['Monday', 'MO'],
  ['Tuesday', 'TU'],
  ['Wednesday', 'WE'],
  ['Thursday', 'TH'],
  ['Friday', 'FR'],
  ['Saturday', 'SA'],
  ['Sunday', 'SU'],
];

const MONTHS: readonly string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const toAllNode = (children: TreeNode[]): TreeNode[] => [
  { title: 'All', value: 'All', key: 'All', children },
];

const dayNodes: TreeNode[] = DAYS.map(([title, code]) => ({ title, value: code, key: code }));

const monthNodes: TreeNode[] = MONTHS.map((title, index) => ({
  title,
  value: index + 1,
  key: index + 1,
}));

const BASE: TreeSelectProps = {
  treeCheckable: true,
  treeDefaultExpandAll: true,
  placeholder: 'Please select group',
  style: { width: '100%' },
  allowClear: true,
  virtual: false,
  showSearch: { treeNodeFilterProp: 'title' },
  maxTagCount: 'responsive',
};

export const RECURRENCE_TREE = {
  day: { ...BASE, treeData: toAllNode(dayNodes) },
  month: { ...BASE, treeData: toAllNode(monthNodes) },
};
